<template>
  <div class="form-input-list">
    <input
      id="id"
      type="text"
      name="name"
      v-model="model"
      ref="inputField"
      class="form-input-list-field"
      v-bind="{ id, name, disabled, required }"
      @blur="hideComboList"
      @focus="showComboList"
      @keyup.enter.stop.prevent="hideComboList">

    <div class="combo-list" role="listbox" aria-haspopup="true" v-show="showList">
      <div
        v-for="item in comboList"
        :key="item.value"
        class="combo-item"
        role="option"
        :class="optionClasses(item.value)"
        @mousedown.prevent="selectItem(item.value)">
        <div class="combo-item-content">
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

 <script>
  export default {
    name: 'form-input-list',
    data: () => ({
      showList: false
    }),
    props: {
      id: String,
      name: [String, Number],
      required: Boolean,
      disabled: Boolean,
      list: [Object, Array],
      value: {}
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$nextTick(() => {
            this.$emit('input', value)
          })
        }
      },
      comboList () {
        let comboList = this.list || {}

        if (this.list[0].constructor !== Object) {
          comboList = this.list.map(current => {
            return {
              value: current,
              text: current
            }
          })
        }

        return comboList
      }
    },
    methods: {
      showComboList (event) {
        this.showList = true
      },
      hideComboList (event) {
        this.showList = false
        if ('activeElement' in document) {
          this.$refs.inputField.blur()
        }
      },
      selectItem (value) {
        this.model = value
        this.showList = false
        if ('activeElement' in document) {
          this.$refs.inputField.blur()
        }
      },
      optionClasses (value) {
        return {
          'menuitem-highlight': this.model === value
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';
  @import '../form-field-default.scss';

  .form-input-list {
    position: relative;
  }

  .form-input-list-field {
    background: url('/assets/images/icon-arrow-down.svg') #fff right 10px bottom 50% no-repeat;
    background-size: 10px auto;
  }

  .combo-list {
    border-radius: 0;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    transition: opacity 0.218s;
    background: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0,0,0,.2);
    cursor: default;
    font-size: 13px;
    margin: 0;
    outline: none;
    padding: 6px 0;
    position: absolute;
    top: 30px;
    left: 0;
    width: 100%;
    height: 150px;
    overflow-y: scroll;
    z-index: 1003;
  }

  .combo-item {
    position: relative;
    color: #333;
    cursor: pointer;
    list-style: none;
    margin: 0;
    padding: 6px 8em 6px 30px;
    white-space: nowrap;
    user-select: none;

    &:hover,
    &.combo-item-highlight,
    &.combo-item-hover {
      background-color: #eee;
      border-color: #eee;
      border-style: dotted;
      border-width: 1px 0;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  .combo-item-content {
    user-select: none;
  }
</style>
